import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import Axios from "axios";
import noData from "../../Assets/img/noData.png";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Visible from "../../../global/Visible";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class OnlineClass extends Component {
  state = {
    data: [],
    loading: true,
    fakeData: [1, 2, 3],
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Online Class";

    var dt = new Date();
    dt.setHours(dt.getHours() - 1);
    if (this.props.user.role.id === 3) {
      this.fetchOnlineClassTeacher({
        meeting_cordinator: this.props.user.user.id,
      });
    } else if (this.props.user.role.id === 9 || this.props.user.role.id === 8) {
      this.fetchOnlineClass({
        for_class: this.props.user.student_class.id,
        for_section: this.props.user.student_section.id,
      });
    } else if (
      this.props.user.role.id === 1 ||
      this.props.user.role.id === 2 ||
      this.props.user.role.id === 5 ||
      this.props.user.role.id === 10
    ) {
      this.fetchOnlineClassTeacher();
    }
  }

  fetchOnlineClass = (params = {}) => {
    Axios.get("/mApiV1/OnlineClassSchedule", { params: { ...params } })
      .then((res) => {
        this.setState({ data: res.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  fetchOnlineClassTeacher = (params = {}) => {
    Axios.get("/mApiV1/TeacherOnlineClassSchedule", { params: { ...params } })
      .then((res) => {
        this.setState({ data: res.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  handleTime = (time) => {
    let hour = time.split(":")[0];
    let min = time.split(":")[1];
    let part = hour >= 12 ? "PM" : "AM";

    min = (min + "").length === 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour + "").length === 1 ? `0${hour}` : hour;

    return `${hour}:${min} ${part}`;
  };

  handleDate = (date) => {
    let year = date.split("-")[0];
    let month = date.split("-")[1];
    let day = date.split("-")[2];

    return `${day}-${month}-${year}`;
  };
  handleDelete = async (id) => {
    Axios.delete(`/courseapi/onlineclassschedule/${id}`)
      .then((res) => {
        if (this.props.user.role.id === 3) {
          this.fetchOnlineClassTeacher({
            meeting_cordinator: this.props.user.user.id,
          });
        } else if (
          this.props.user.role.id === 9 ||
          this.props.user.role.id === 8
        ) {
          this.fetchOnlineClass({
            for_class: this.props.user.student_class.id,
            for_section: this.props.user.student_section.id,
          });
        } else if (
          this.props.user.role.id === 1 ||
          this.props.user.role.id === 2 ||
          this.props.user.role.id === 5 ||
          this.props.user.role.id === 10
        ) {
          this.fetchOnlineClassTeacher();
        }
      })
      .catch((err) => {});
  };

  render() {
    console.log(this, "this in online class");
    return (
      <React.Fragment>
        <Header to="/home" title="Live Class" />
        <Visible
          roles={["IS_TEACHER", "IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
          redirect
          to="/"
        >
          <div
            className="text-center position-fixed w-100"
            style={{ bottom: 80, zIndex: 100 }}
          >
            <Link
              type="button"
              className="th-btn-primary shadow py-2 px-3"
              to="/addonlineclass"
            >
              ADD MEETING
            </Link>
          </div>
        </Visible>

        <div className="container pt-3 col-12">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border rounded shadow-sm p-3 mb-3"
                  >
                    <Skeleton />
                    <Skeleton width={200} />
                    <Skeleton width={200} />
                  </div>
                );
              })
            : null}

          {this.state.data.length !== 0 && this.state.loading === false
            ? this.state.data?.map((item, index) => {
                var urlPattern = /^((http|https|ftp):\/\/)/;
                let meetingUrl = "";
                if (!urlPattern.test(item.meeting_link)) {
                  meetingUrl = "http://" + item.meeting_link;
                } else {
                  meetingUrl = item.meeting_link;
                }
                return (
                  <div
                    key={index}
                    className="border rounded shadow-sm p-3 mb-3"
                  >
                    <div className="d-flex justify-content-between pb-2">
                      <div className="pr-3">
                        <div className="th-12 th-black th-bold">
                          {item?.meeting_name}
                        </div>
                        <div className="th-12 th-grey">
                          <span> {item?.subject__subject}</span>{" "}
                          <Visible
                            roles={[
                              "IS_TEACHER",
                              "IS_PRINCIPAL",
                              "IS_ADMIN",
                              "IS_SUPERADMIN",
                              "IS_ACCOUNTANT",
                            ]}
                          >
                            {" "}
                            <>
                              {" "}
                              <span className="pl-3">
                                {item?.for_class__class_name}
                              </span>
                              <span className="pl-1">
                                {item?.for_section__section_name}
                              </span>
                            </>
                          </Visible>
                        </div>
                      </div>
                      <div className="my-auto">
                        <a href={meetingUrl}>
                          <button className="btn th-btn-primary-outline px-3 py-2 th-bold">
                            {this.props.user?.role?.id === 9 ? "Join" : "Start"}
                          </button>
                        </a>
                      </div>
                    </div>
                    <div className="th-12">
                      Coordinator: {item?.meeting_cordinator__first_name}
                    </div>

                    <div className="d-flex justify-content-between">
                      <div className="pr-3">
                        <div className="th-12 th-black">
                          Date:{" "}
                          {this.handleDate(
                            item?.meeting_datetime?.split("T")[0]
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="th-12 th-black">
                          Start time:{" "}
                          {this.handleTime(
                            item?.meeting_datetime?.split("T")[1]
                          )}
                        </div>
                      </div>
                    </div>
                    <Visible
                      roles={[
                        "IS_TEACHER",
                        "IS_PRINCIPAL",
                        "IS_ADMIN",
                        "IS_SUPERADMIN",
                        "IS_ACCOUNTANT",
                      ]}
                    >
                      <div className=" text-right">
                        <div className="">
                          <div className="th-16 th-primary">
                            <i
                              className="fa fa-trash"
                              aria-hidden="true"
                              onClick={() => this.handleDelete(item.id)}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </Visible>
                  </div>
                );
              })
            : null}

          {this.state.data.length === 0 && this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                Enjoy!! No upcoming live class.
              </p>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(OnlineClass);
